module.exports = __webpack_public_path__ + "static/media/break-ice.36aa7a17.mp3";